import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { PaymentStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('payment', reducer),
        EffectsModule.forFeature([PaymentStoreEffects])
    ],
    providers: []
})
export class PaymentStoreModule {}
